/**
 * Constantes centralizadas para ShareLineupImage
 * Define todas las dimensiones y configuraciones del canvas
 */

export const CANVAS_CONFIG = {
  width: 1080,
  height: 1920,
  defaultPitchTop: 470,
  avatarRadius: 75,
  pitchMargins: {
    left: 60,
    right: 60,
    bottom: 200,
  },
};

export const AVATAR_DIAMETER = CANVAS_CONFIG.avatarRadius * 2;

/**
 * Estilos base reutilizables
 */
export const STYLE_DEFAULTS = {
  avatar: {
    borderRadius: "50%",
    overflow: "hidden",
    background: "#ffffff",
    flexShrink: 0,
  },
  nameContainer: {
    background: "#ffffff",
    borderRadius: "15px",
    padding: "2px 5px",
    textAlign: "center",
    lineHeight: 1.2,
    position: "relative",
    display: "flex",
    fontWeight: "600",
    textTransform: "uppercase",
    fontSize: "22px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
};